import { IamAuthProvider } from "@itaas/core/auth/IamAuthProvider";
import { suiteSessionApi } from "@/auth/suite-auth.service";

interface SuiteAuthProviderProps {
  children: React.ReactNode;
}

export function SuiteAuthProvider({ children }: SuiteAuthProviderProps) {
  return (
    <IamAuthProvider
      api={suiteSessionApi}
      redirectOnLogout={false}
      localLogoutPath="/auth/logout"
    >
      {children}
    </IamAuthProvider>
  );
}
